import { render, staticRenderFns } from "./DetailsTextShimmer.vue?vue&type=template&id=40745c00&"
import script from "./DetailsTextShimmer.vue?vue&type=script&lang=js&"
export * from "./DetailsTextShimmer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports